<template>
  <div id="ecommerce-checkout-demo" class="shop-wrapper">
    <div class="w-full flex flex-col lg:flex-row md:flex-row">
      <div class="w-full lg:w-3/5 md:w-3/5">
        <Tabs :onClick="onClick" :active="active" />
        <div class="py-4">
          <form-wizard ref="checkoutWizard" color="rgba(var(--vs-primary), 1)" :title="null" :subtitle="null"
            :hide-buttons="true">
            <!-- STORE LIMITATION -->
            <div>
              <vs-card :key="limitation._id" v-for="limitation in limitationsList ">
                <p v-if="limitation.isAboveMax" class=" text-base text-danger">{{ limitation.display_message_max }}</p>
                <p v-if="limitation.isBelowMin" class=" text-base text-danger">{{ limitation.display_message_min }}</p>
                <p v-if="limitation.isBelowAmount" class="text-base text-danger">
                  {{ limitation.display_purchase_message_min }}
                </p>
              </vs-card>
            </div>
            <!-- STORE LIMITATION -->
            <div v-if="active === 1">
              <div class="items-list-view" v-for="item in cartItems" :key="item._id">
                <checkout-list-view :item="item" class="mb-4">
                  <!-- SLOT: ITEM META -->
                  <template slot="remove">
                    <div
                        class="w-1/2 lg:w-32 flex items-center justify-center"
                        >
                        <x-icon size="1.5x" class="cursor-pointer" @click="removeItemFromCart(item)"></x-icon>
                      </div>
                  </template>
                  <template slot="item-meta">
                    <h6 class="
                        item-name
                        font-semibold
                        mb-1
                        cursor-pointer
                        hover:text-primary
                      " @click="
                        $router
                          .push({
                            name: 'ecommerce-item-detail-view',
                            params: { item_id: item._id },
                          })
                          .catch(() => { })
                      ">
                      {{ item.name }}
                    </h6>
                    <p class="text-sm mb-2">
                      By
                      <span class="font-semibold cursor-pointer">{{
                          item.brand
                      }}</span>
                    </p>
                    <p class="text-success text-sm">In Stock</p>

                    <br />
                    <span class="text-danger" style="font-size: 0.75em">{{
                        errors.firstById(item._id)
                    }}</span>
                  </template>

                  <!-- SLOT: ACTION BUTTONS -->
                  <template slot="action-buttons">
                    <div class=" w-full lg:w-auto flex flex-row lg:flex-col justify-end items-end lg:justify-none">
                      <vs-input-number
                        v-validate="'required'"
                        class="w-full"
                        max="999"
                        min="1"
                        :is-disabled="disableInput"
                        :disabled="disableInput"
                        v-model="item.quantity"
                        type="number"
                        @input="increase(item)"
                        @change="increase(item)"
                        @focusout = "item.quantity = item.quantity|| 1"
                      />

                    </div>
                  </template>
                </checkout-list-view>
              </div>
            </div>
            <div v-if="active === 2">
              <vx-card title="Shipping Details" subtitle="" class="mb-base">
                <form data-vv-scope="add-new-address">
                  <p class="pb-2 font-semibold">Delivery Address</p>
                  <p>{{ shippingDetails.address.displayAddress }}</p>
                  <p class="py-5 font-semibold">Hours of operation</p>
                  <div class="w-full sm:w-1/2">
                    <div class="vx-row">
                      <div class="vx-col sm:w-1/5 w-full">
                        <p class="pt-2">Monday</p>
                      </div>
                      <div class="vx-col sm:w-4/5 w-full">
                        <vs-input v-validate="'required'" data-vv-as="field" name="monday" class="w-full"
                          placeholder="9-5 or closed" v-model="operations.monday" />
                      </div>
                    </div>
                    <div class="vx-row mt-2">
                      <div class="vx-col sm:w-1/5 w-full">
                        <p class="pt-2">Tuesday</p>
                      </div>
                      <div class="vx-col sm:w-4/5 w-full">
                        <vs-input data-vv-as="field" name="tuesday" class="w-full" placeholder="9-5 or closed"
                          v-model="operations.tuesday" />
                      </div>
                    </div>
                    <div class="vx-row mt-2">
                      <div class="vx-col sm:w-1/5 w-full">
                        <p class="pt-2">Wednesday</p>
                      </div>
                      <div class="vx-col sm:w-4/5 w-full">
                        <vs-input data-vv-as="field" name="wednesday" class="w-full" placeholder="9-5 or closed"
                          v-model="operations.wednesday" />
                      </div>
                    </div>
                    <div class="vx-row mt-2">
                      <div class="vx-col sm:w-1/5 w-full">
                        <p class="pt-2">Thursday</p>
                      </div>
                      <div class="vx-col sm:w-4/5 w-full">
                        <vs-input data-vv-as="field" name="thursday" class="w-full" placeholder="9-5 or closed"
                          v-model="operations.thursday" />
                      </div>
                    </div>
                    <div class="vx-row mt-2">
                      <div class="vx-col sm:w-1/5 w-full">
                        <p class="pt-2">Friday</p>
                      </div>
                      <div class="vx-col sm:w-4/5 w-full">
                        <vs-input data-vv-as="field" name="friday" class="w-full" placeholder="9-5 or closed"
                          v-model="operations.friday" />
                      </div>
                    </div>
                    <div class="vx-row mt-2">
                      <div class="vx-col sm:w-1/5 w-full">
                        <p class="pt-2">Saturday</p>
                      </div>
                      <div class="vx-col sm:w-4/5 w-full">
                        <vs-input data-vv-as="field" name="saturday" class="w-full" placeholder="9-5 or closed"
                          v-model="operations.saturday" />
                      </div>
                    </div>
                    <div class="vx-row mt-2">
                      <div class="vx-col sm:w-1/5 w-full">
                        <p class="pt-2">Sunday</p>
                      </div>
                      <div class="vx-col sm:w-4/5 w-full">
                        <vs-input data-vv-as="field" name="sunday" class="w-full" placeholder="9-5 or closed"
                          v-model="operations.sunday" />
                      </div>
                    </div>
                  </div>
                  <div class="vx-row hidden">
                    <div class="vx-col sm:w-1/2 w-full">
                      <vs-input data-vv-as="field" name="clinicName" label="Clinic Name:"
                        v-model="shippingDetails.clinicName" class="w-full mt-5" disabled />
                    </div>

                    <div class="vx-col sm:w-1/2 w-full">
                      <vs-input name="email" label="Email:" v-model="shippingDetails.email" class="w-full mt-5"
                        disabled />
                    </div>
                  </div>

                  <div class="vx-row hidden">
                    <div class="vx-col sm:w-1/2 w-full">
                      <vs-input name="displayAddress" label="Address:" v-model="shippingDetails.address.displayAddress"
                        class="w-full mt-5" disabled />
                    </div>

                    <div class="vx-col sm:w-1/2 w-full">
                      <vs-input name="postCode" label="Post Code:" v-model="shippingDetails.address.postCode"
                        class="w-full mt-5" disabled />
                    </div>
                  </div>

                  <div class="vx-row hidden">
                    <div class="vx-col sm:w-1/2 w-full">
                      <vs-input v-validate="'required'" name="state" label="State:"
                        v-model="shippingDetails.address.state" class="w-full mt-5" disabled />
                    </div>

                    <div class="vx-col sm:w-1/2 w-full">
                      <vs-input name="suburb" label="Suburb:" v-model="shippingDetails.address.suburb"
                        class="w-full mt-5" disabled />
                    </div>
                  </div>

                  <p class="mt-10">
                    If you wish to change your delivery address please contact
                    fresh clinics.
                  </p>
                  <p class="mt-4">info@freshclinics.com.au</p>
                </form>
              </vx-card>
            </div>
            <div v-if="active === 3">
              <div class="relative">
                <vs-popup class="holamundo" title="Add payment method" :active.sync="popupActive">
                  <vs-tabs>
                    <vs-tab label="Credit Card" @click="paymentType = 'CreditCard'">
                      <stripe-elements ref="stripeElement" v-bind:title="saveCreditCard" :pk="stripePublishableKey"
                        :amount="totalPrice" locale="en" @token="tokenCreated" @loading="loading = $event">
                      </stripe-elements>
                      <vs-button @click="submit">Confrim</vs-button>
                    </vs-tab>
                    <vs-tab label="Bank Account" @click="paymentType = 'ClinicBankAccount'" v-if="!isUS">
                      <BankSetup :totalPrice="totalPrice" :financialDetails="financialDetails"
                        :isNewClinicBankAccount="isNewClinicBankAccount" :shippingDetails="shippingDetails"
                        :paymentType="'ClinicBankAccount'" @onClinicBankPaymentSuccess="clinicBankPaymentSuccess">
                      </BankSetup>
                    </vs-tab>
                  </vs-tabs>
                </vs-popup>
                <div class="bg-white flex flex-col roundex-lg shadow-lg rounded-lg">
                  <div class="px-6 p-4">
                    <h4>Payment options</h4>
                  </div>

                  <h5 class="px-6">Selected Payment Methods</h5>
                  <div>
                    <ul>
                      <!-- OPTION 1 -->

                      <!-- OPTION 2 -->
                      <li v-for="(card, index) in cardDetails" :key="index">
                        <div class="flex flex-row p-4 px-6">
                          <div class="pr-4 pt-1">
                            <vs-radio v-model="paymentType" :vs-value="card.cardId" />
                          </div>
                          <div>
                            <p>{{ card.brand }}</p>
                            <p>XXXX XXXX XXXX {{ card.last4 }}</p>
                            <p>
                              {{ card.exp_month }} /
                              {{ card.exp_year }}
                            </p>
                          </div>
                        </div>
                      </li>
                      <li v-if="defaultCard">
                        <div class="flex flex-row p-4 px-6">
                          <div class="pr-4 pt-1">
                            <vs-radio v-model="paymentType" vs-value="SavedCard" />
                          </div>
                          <div>
                            <p>{{ defaultCard.brand }}</p>
                            <p>XXXX XXXX XXXX {{ defaultCard.last4 }}</p>
                            <p>
                              {{ defaultCard.exp_month }} /
                              {{ defaultCard.exp_year }}
                            </p>
                          </div>
                        </div>
                      </li>
                      <li v-if="financialDetails">
                        <div class="flex flex-row p-4 px-6">
                          <div class="pr-4 pt-1">
                            <vs-radio v-model="paymentType" vs-value="SavedClinicBankAccount" />
                          </div>
                          <div>
                            <p>{{ financialDetails.accountHolderName }}</p>
                            <p>{{ financialDetails.accountHolderEmail }}</p>
                            <p>
                              {{ financialDetails.bsb }}/{{
                                  financialDetails.accountNumber
                              }}
                            </p>
                          </div>
                        </div>
                      </li>
                      <li v-if="isAccessPaymentTerms">
                        <div class="flex flex-row p-4 px-6">
                          <div class="pr-4 pt-1">
                            <vs-radio v-model="paymentType" vs-value="PaymentTermsInvoice" />
                          </div>
                          <div class="vx-col">
                            <p>Payment Terms - Invoice</p>
                          </div>
                        </div>
                      </li>
                    </ul>
                    <ul v-if="false">
                      <!-- OPTION 1 -->

                      <!-- OPTION 2 -->
                      <li>
                        <div class="flex flex-wrap justify-between items-center">
                          <vs-radio v-model="paymentType" vs-value="CreditCard">Credit Card</vs-radio>
                        </div>
                        <div v-if="paymentType == 'CreditCard'">
                          <stripe-elements ref="stripeElement" v-bind:title="saveCreditCard" :pk="stripePublishableKey"
                            :amount="totalPrice" locale="en" @token="tokenCreated" @loading="loading = $event">
                          </stripe-elements>
                          <vs-checkbox ref="saveCard" v-model="saveCreditCard" class="mb-6">Save card?</vs-checkbox>
                          <vs-button class="mb-2" @click="submit">Confrim</vs-button>
                        </div>
                      </li>
                      <li class="mt-2 mb-2" v-if="cardDetails">
                        <vs-radio v-model="paymentType" vs-value="SavedCard">Use Saved Card</vs-radio>
                        <div v-if="paymentType == 'SavedCard'">
                          <div class="vx-row">
                            <div class="vx-col lg:w-1/2 w-full">
                              <vx-card title="Card Details" subtitle="" class="mb-base">
                                <p>{{ cardDetails.brand }}</p>

                                <p>XXXX XXXX XXXX {{ cardDetails.last4 }}</p>
                                <p>
                                  {{ cardDetails.exp_month }} /
                                  {{ cardDetails.exp_year }}
                                </p>
                              </vx-card>
                              <vs-button class="w-full" @click="sendToServer({ amount: totalPrice })">Confirm And
                                Pay</vs-button>
                            </div>
                          </div>
                        </div>
                      </li>
                      <li class="mt-2 mb-2" v-if="financialDetails">
                        <vs-radio v-model="paymentType" vs-value="ClinicBankAccount">Clinic Bank Account
                          <a class="ml-3" @click="
                            isNewClinicBankAccount = !isNewClinicBankAccount
                          " v-if="paymentType == 'ClinicBankAccount'">Change</a></vs-radio>
                        <div class="newBankDetail" v-if="
                          paymentType == 'ClinicBankAccount' &&
                          isNewClinicBankAccount
                        ">
                          <BankSetup :totalPrice="totalPrice" :financialDetails="financialDetails"
                            :isNewClinicBankAccount="isNewClinicBankAccount" :shippingDetails="shippingDetails"
                            :paymentType="paymentType" @onClinicBankPaymentSuccess="
                              clinicBankPaymentSuccess
                            "></BankSetup>
                        </div>

                        <div class="financialDetails" v-if="
                          paymentType == 'ClinicBankAccount' &&
                          !isNewClinicBankAccount &&
                          financialDetails
                        ">
                          <div class="vx-row">
                            <div class="vx-col lg:w-1/2 w-full">
                              <vx-card title="Bank Details" subtitle="" class="mb-base">
                                <p>{{ financialDetails.accountHolderName }}</p>
                                <p>{{ financialDetails.accountHolderEmail }}</p>

                                <p>
                                  {{ financialDetails.bsb }}/
                                  {{ financialDetails.accountNumber }}
                                </p>
                              </vx-card>
                            </div>
                          </div>
                        </div>
                      </li>
                      <li class="mt-2" v-if="isAccessPaymentTerms">
                        <vs-radio v-model="paymentType" vs-value="PaymentTermsInvoice">Payment Terms -
                          Invoice</vs-radio>
                        <div v-if="paymentType == 'PaymentTermsInvoice'">
                          <vs-button @click="sendToServer({ amount: totalPrice })">Submit Order</vs-button>
                        </div>
                      </li>
                    </ul>
                  </div>
                  <div class="border p-6 mt-5" style="border-top: solid 1px #e0e0e0">
                    <div class="
                        flex flex-row
                        bg-primary
                        p-3
                        rounded-lg
                        text-white
                        cursor-pointer
                      " style="width: 230px" @click="openPopup">
                      <plus-icon size="1.5x" class="custom-class"></plus-icon>
                      <div class="pl-4 pt-1">Add Payment Method</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form-wizard>
        </div>
      </div>
      <div class="w-full lg:w-2/5 md:w-2/5 lg:px-4 md:px-4">
        <div v-if="active === 1">
          <div v-if="hasOrganization" class="w-full">
            <SwapClinic :title="thisCartText" :onChange="onChange" />
          </div>
          <vx-card>
            <p class="font-semibold mb-3" style="font-size: 16px">
              Price Details
            </p>
            <div class="flex justify-between mb-2">
              <span class="text-grey">Sub Total</span>
              <span>{{ currency }} ${{ subTotal | formatDecimals }}</span>
            </div>
            <div class="flex justify-between mb-2" v-for="discountItem in discountsArray" :key='discountItem._id'>
              <span class="text-grey"> {{ discountItem.rule.discount_title }}</span>
              <span class="text-success">{{ currency }} ${{ discountItem.totalDiscount | formatDecimals }} </span>
            </div>
            <div class="flex justify-between mb-2" v-for="freeShippingItem in freeShippingArray"
              :key='freeShippingItem._id'>
              <span class="text-grey"> {{ freeShippingItem.free_shipping_name }}</span>
              <span class="text-success">{{ currency }} ${{ freeShippingItem.totalDiscount | formatDecimals }} </span>
            </div>
            <div class="flex justify-between mb-2">
              <span class="text-grey"> Delivery</span>
              <span class="text-success">{{ currency }} {{ deliveryCharge | formatDecimals }}</span>
            </div>
            <div class="flex justify-between mb-2" v-if="creditCardTransactionFee > 0">
              <span class="text-grey w-3/5">
                2% card transaction fee applies</span>
              <span class="text-success">{{ currency }} ${{
                  creditCardTransactionFee | formatDecimals
              }}</span>
            </div>
            <div class="flex justify-between mb-2" v-if="paymentEfficiencyBenefit > 0">
              <span class="text-grey w-3/5">Payment Efficiency Discount</span>
              <span class="text-success">-{{ currency }} ${{
                  paymentEfficiencyBenefit | formatDecimals
              }}</span>
            </div>
            <div class="flex justify-between mb-2" v-if="!isUS">
              <span class="text-grey">GST (10%)</span>
              <span>{{ currency }} ${{ gstTotal | formatDecimals }}</span>
            </div>
            <div class="flex justify-between mb-2" v-if="isUS">
              <span class="text-grey">Taxes</span>
              <span>{{ currency }} ${{ tax | formatDecimals }}</span>
            </div>

            <vs-divider />

            <div class="flex justify-between font-semibold mb-3">
              <span>Total</span>
              <span>{{ currency }} ${{ totalPrice | formatDecimals }}</span>
            </div>

            <vs-button class="w-full" :disabled="!validateForm || cartItems.length <= 0"
              @click="onClick(2)">NEXT</vs-button>
          </vx-card>

          <vx-card>
            <p class="font-semibold mb-3">Add Notes</p>
            <vs-textarea data-vv-as="field" name="notes" :maxlength="max" v-model="shippingDetails.notes"
              class="w-full h-20 mt-5"></vs-textarea>
          </vx-card>
        </div>
        <div v-if="active === 2">
          <div v-if="hasOrganization" class="w-full">
            <SwapClinic :title="thisCartText" :onChange="onChange" />
          </div>
          <vx-card :title="shippingDetails.clinicName">
            <div>
              <p>{{ shippingDetails.address.displayAddress }}</p>
            </div>

            <vs-divider />
            <div v-if="deliveryButtonDisabled" class="w-full p-3 text-center rounded text-white"
              style="background-color: #a0a0a0">
              Deliver to this Address
            </div>
            <vs-button v-if="!deliveryButtonDisabled" class="w-full" @click="onClick(3)">Deliver to this
              Address</vs-button>
          </vx-card>
          <vx-card>
            <p class="font-semibold mb-3">Order Notes</p>
            <p class="font-regular mb-3 break-all">
              {{ shippingDetails.notes }}
            </p>
          </vx-card>
        </div>
        <div v-if="active === 3">
          <div v-if="hasOrganization" class="w-full">
            <SwapClinic :title="thisCartText" :onChange="onChange" />
          </div>
          <vx-card>
            <p class="font-semibold mb-3" style="font-size: 16px">
              Price Details
            </p>
            <p style="color: #999999">
              Please note there is a maximum purchase of $30,000 {{ currency }}
            </p>
            <div style="
                width: 100%;
                margin: 15px 0;
                border-bottom: solid 1px #e0e0e0;
              "></div>
            <div class="flex justify-between mb-2">
              <span class="text-grey">Sub Total</span>
              <span>{{ currency }} ${{ subTotal | formatDecimals }}</span>
            </div>
            <div class="flex justify-between mb-2" v-for="discountItem in discountsArray" :key='discountItem._id'>
              <span class="text-grey"> {{ discountItem.rule.discount_title }}</span>
              <span class="text-success">{{ currency }} ${{ discountItem.totalDiscount | formatDecimals }} </span>
            </div>
            <div class="flex justify-between mb-2" v-for="freeShippingItem in freeShippingArray"
              :key='freeShippingItem._id'>
              <span class="text-grey"> {{ freeShippingItem.free_shipping_name }}</span>
              <span class="text-success">{{ currency }} ${{ freeShippingItem.totalDiscount | formatDecimals }} </span>
            </div>
            <div class="flex justify-between mb-2">
              <span class="text-grey"> Delivery</span>
              <span class="text-success">{{ currency }} ${{ deliveryCharge | formatDecimals }}</span>
            </div>
            <div class="flex justify-between mb-2" v-if="creditCardTransactionFee > 0">
              <span class="text-grey"> 2% card transaction fee applies</span>
              <span class="text-success">{{ currency }} ${{
                  creditCardTransactionFee | formatDecimals
              }}</span>
            </div>
            <div class="flex justify-between mb-2" v-if="paymentEfficiencyBenefit > 0">
              <span class="text-grey"> Payment Efficiency Discount</span>
              <span class="text-success">-{{ currency }} ${{
                  paymentEfficiencyBenefit | formatDecimals
              }}</span>
            </div>
            <div class="flex justify-between mb-2" v-if="!isUS">
              <span class="text-grey">GST (10%)</span>
              <span>{{ currency }} ${{ gstTotal | formatDecimals }}</span>
            </div>
            <div class="flex justify-between mb-2" v-if="isUS">
              <span class="text-grey">Taxes</span>
              <span>{{ currency }} ${{ tax | formatDecimals }}</span>
            </div>
            <vs-divider />

            <div class="flex justify-between font-semibold mb-3">
              <span>Total</span>
              <span>{{ currency }} ${{ totalPrice | formatDecimals }}</span>
            </div>
            <vs-button v-if="paymentType" class="w-full" @click="sendToServer({ amount: totalPrice })"
              :disabled="!isOrderLimitExempt && totalPrice > 29999 * 100">Confirm</vs-button>
            <div v-if="!paymentType" class="w-full p-3 text-center rounded text-white"
              style="background-color: #a0a0a0">
              Confirm
            </div>
          </vx-card>
          <vx-card>
            <p class="font-semibold mb-3">Order Notes</p>
            <p class="font-regular mb-3 break-all">
              {{ shippingDetails.notes }}
            </p>
          </vx-card>
        </div>
      </div>
    </div>
    <vs-popup class="holamundo" title="Outstanding Payment" :active.sync="popupActive2">
      <div class="flex flex-no-wrap">
        <div class="w-1/6 flex items-center justify-center">
          <vs-icon icon="clear" size="medium" bg="#f9d6d6" color="#b21f1e" round></vs-icon>
        </div>
        <div class="w-5/6">
          <p>
            Sorry! Your account has an outstanding product payment. Please
            complete your payment before continuing.
            <br />Need help? Call 1300 375 646
          </p>
        </div>
      </div>
      <div class="flex justify-between mt-5">
        <vs-button class="mr-4 mb-4" @click="popupActive2 = false">
          Close
        </vs-button>
        <vs-button class="mr-4 mb-4" @click="goToOrders()">
          Go to payment
        </vs-button>
      </div>
    </vs-popup>
  </div>
</template>

<script>
import { FormWizard } from 'vue-form-wizard';
import 'vue-form-wizard/dist/vue-form-wizard.min.css';
import { mapActions, mapMutations } from 'vuex';
import _ from 'lodash';
const CheckoutListView = () => import('./CheckoutListView.vue');
import StripeElements from './StripeElements';
import BankSetup from './BankSetup';
import Tabs from '../../../layouts/components/tabs/tabs.vue';
import { PlusIcon, XIcon } from 'vue-feather-icons';
import SwapClinic from '../../components/shop/clinic.vue';
import StoreHelper from '../../../mixins/Store.vue';
import CheckoutHelper from '../../../mixins/Checkout.vue';

export default {
  name: 'Checkout',
  mixins: [StoreHelper, CheckoutHelper],
  data() {
    return {
      cartItems:[],
      disableInput: false,
      hasOrganization: false,
      stripePublishableKey: process.env.VUE_APP_STRIPE_PUBLISHABLE_KEY,
      saveCreditCard: true,
      isSavedAddress: false,
      selectedMode: null,
      cardDetails: [],
      defaultCard: null,
      financialDetails: null,
      isNewClinicBankAccount: true,
      isAccessPaymentTerms: false,
      paymentMode: null,
      bankMode: null,
      popupActive: false,
      role: null,
      shippingDetails: {
        clinicName: '',
        address: {},
        email: '',
        notes: '',
      },
      card: {
        number: '',
        cvc: '',
        exp: '',
      },
      isCreditCard: false,
      max: 200,
      // TAB 3
      paymentType: null,
      popupActive2: false,
      active: 1,
      operations: {
        monday: null,
        tuesday: null,
        wednesday: null,
        thursday: null,
        friday: null,
        saturday: null,
        sunday: null,
      },
      deliveryButtonDisabled: true,
      isUS: true,
      currency: process.env.VUE_APP_CURRENCY,
      region: process.env.VUE_APP_REGION,
      tax: 0,
      thisCartText: 'This cart is for:',
    };
  },
  computed: {
    totalPriceDiscountAndDeliveryCharge() {
      let discount = 0;
      this.discountsArray.forEach(discountItem => {
        discount += discountItem.totalDiscount;
      });
      return (
        this.$store.getters['eCommerce/totalCarPrice'] - discount + this.deliveryCharge
      );
    },
    totalPrice() {
      const creditCardFee = this.creditCardTransactionFee;
      let total =
        this.totalPriceDiscountAndDeliveryCharge + creditCardFee - this.paymentEfficiencyBenefit;

      if (this.region === 'AU') {
        total = total + this.gstTotal;
      }
      return total + this.tax;
    },
    gstTotal() {
      // No taxable/GST-free item split exists in this checkout's cart data,
      // so GST already applies uniformly to the whole merchandise base —
      // unlike org-owner, subtracting the benefit here needs no apportionment.
      let gst =
        ((this.totalPriceDiscountAndDeliveryCharge +
          this.creditCardTransactionFee -
          this.paymentEfficiencyBenefit) *
          10) /
        100;
      return gst;
    },
    paymentEfficiencyBenefit() {
      // PayTo and Direct Debit, plus Payment Terms while the server's terms
      // flag is on, in place of the retired 2% card surcharge. Matches the
      // server; the rate comes from the server.
      if (!this.paymentEfficiencyBenefitActive) return 0;
      const isPaymentTerms = this.paymentType === 'PaymentTermsInvoice' && this.paymentTermsBenefitActive;
      if (!['PayTo', 'ClinicBankAccount', 'SavedClinicBankAccount'].includes(this.paymentType) && !isPaymentTerms) return 0;

      let discount = 0;
      this.discountsArray.forEach(discountItem => {
        discount += discountItem.totalDiscount;
      });
      // Merchandise only, delivery fee excluded — the one place this base
      // differs from creditCardTransactionFee's, which does include delivery.
      const base = this.subTotal - discount;
      return ((base * (this.paymentEfficiencyBenefitRate || 0)) / 100).toFixed(2) * 100;
    },
    deliveryCharge() {
      return this.$store.getters['eCommerce/delivery'];
    },
    creditCardTransactionFee() {
      // FRH-732: retired in AU from 1 Oct 2026 (RBA), still charged elsewhere.
      if (!this.cardSurchargeActive) return 0;

      if (
        this.paymentType &&
        ![
          'ClinicBankAccount',
          'SavedClinicBankAccount',
          'PaymentTermsInvoice',
        ].includes(this.paymentType)
      ) {
        const creditCardCharge =
          (this.totalPriceDiscountAndDeliveryCharge * 2) / 100;
        return creditCardCharge;
      }
      return 0;
    },
    // CPC-651: Stripe blocks direct debit orders over $30k, but card and
    // payment terms orders should still be allowed through.
    isOrderLimitExempt() {
      const bankAccountPaymentTypes = ['ClinicBankAccount', 'SavedClinicBankAccount'];
      return !!this.paymentType && !bankAccountPaymentTypes.includes(this.paymentType);
    },
    discountTotal() {
      return (
        this.subTotal +
        this.deliveryCharge +
        this.creditCardTransactionFee +
        this.gstTotal -
        this.totalPrice
      );
    },
    subTotal() {
      return this.$store.getters['eCommerce/subTotalCartPrice'];
    },
    isInWishList() {
      return (itemId) => this.$store.getters['eCommerce/isInWishList'](itemId);
    },
    validateForm() {
      return !this.errors.any();
    },
  },
  async created() {
    await this.getCartItems();
    const userDetail = await this.getUserDetail();
    this.isUS = process.env.VUE_APP_REGION === 'US';
    this.shippingDetails = userDetail;
    if (this.$store.state.AppActiveUser.defaultPaymentMethod) {
      this.paymentType =
        this.$store.state.AppActiveUser.defaultPaymentMethod === 'CreditCard'
          ? 'SavedCard'
          : 'SavedClinicBankAccount';
    }
    if (this.isUS)
      this.getUSTax();
  },
  watch: {
    '$store.state.eCommerce.cartItems': {
      handler(val) {
        this.cartItems=JSON.parse(JSON.stringify(val.slice().reverse()));
      },
      immediate: true,
    },
    operations: {
      deep: true,
      handler(value) {
        const isDisabled = Object.keys(value).filter(
          (k) => !value[k] || value[k] === ''
        );
        if (isDisabled.length <= 0) {
          this.deliveryButtonDisabled = false;
        } else {
          this.deliveryButtonDisabled = true;
        }
      },
    },
    cartItems: function (val) {
      this.deliveryButtonDisabled = val.length > 0 ? false : true;
    },
    popupActive: function (val) {
      if (!val && !this.isCreditCard) {
        if (this.$store.state.AppActiveUser.defaultPaymentMethod) {
          this.paymentType =
            this.$store.state.AppActiveUser.defaultPaymentMethod ===
              'CreditCard'
              ? 'SavedCard'
              : 'SavedClinicBankAccount';
        } else {
          this.paymentType = null;
        }
      }
    },
    '$store.state.clinicId': function () {
      this.getCartItems();
      this.updateHoursOfOPeration(this.$store.state.operations);
      if (this.$store.state.clinic && this.$store.state.clinic.length) {
        this.shippingDetails = this.$store.state.clinic[0];
      }

      if (this.cartItems.length && (this.active === 3 || this.active === 2)) {
        this.active = 1;
      }
      this.isUS = process.env.VUE_APP_REGION === 'US';
      if (this.isUS)
        this.getUSTax();
    },
  },
  methods: {
    ...mapMutations('ecommerce', ['REMOVE_ALL_ITEMS_IN_CART']),
    ...mapActions('ecommerce', ['getCartItemsFromApi', 'paymentForCartItems']),
    ...mapActions('general', [
      'fetchUserDetails',
      'fetchCardDetails',
      'fetchCardDetailsList',
      'taxJarCalculateOrderTax',
    ]),
    getUSTax() {
      const data = {
        'from_country': 'US',
        'from_zip': this.shippingDetails.address.postCode,
        'from_state': this.shippingDetails.address.state,
        'from_city': this.shippingDetails.address.suburb,
        'from_street': this.shippingDetails.address.displayAddress,
        'amount': this.totalPrice / Math.pow(10, 2),
        'shipping': '0',
        'to_country': 'US',
        'to_zip': this.shippingDetails.address.postCode,
        'to_state': this.shippingDetails.address.state,
        'to_city': this.shippingDetails.address.suburb,
        'to_street': this.shippingDetails.address.displayAddress,
      };
      this.taxJarCalculateOrderTax(data)
        .then((res) => {
          this.tax = res.data.data.tax.amount_to_collect * 100;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    updateHoursOfOPeration(val) {
      if (val && Object.keys(val).length) {
        this.operations = val;
      }
    },
    onClick(val) {
      if (this.cartItems.length <= 0 && val === 2) {
        this.active = 1;
      } else if (!this.deliveryButtonDisabled && val === 3) {
        this.active = val;
      } else if (val !== 3) {
        this.active = val;
      }
    },
    clinicBankPaymentSuccess(message = null) {
      if (message && message === 'OUTSTANDING_PAYMENT') {
        this.$vs.loading.close();
        this.popupActive2 = true;
        return;
      } else {
        this.popupActive = false;
        this.getCartItems();
      }
    },
    openPopup() {
      this.popupActive = true;
      this.paymentType = 'CreditCard';
    },
    goToOrders() {
      this.popupActive2 = false;
      const role = this.$store.state.AppActiveUser.userRole;
      let path = '';
      switch (role) {
      case 'doctorClinic':
        path = '/doctor-clinic/orders';
        break;
      case 'clinic':
        path = '/clinic/orders';
        break;
      case 'nurse':
        path = '/nurse/orders';
        break;
      case 'franchise':
        path = '/franchise/orders';
        break;
      case 'doctor':
        path = '/doctor/orders';
        break;
      case 'dermaSpecialist':
        path = '/derma-specialist/orders';
        break;
      default:
        path = '';
        break;
      }
      if (this.role && this.role === 'Org Owner') {
        path = '/org-owner/orders';
      }
      setTimeout(() => {
        this.$router.push({ path });
      }, 200);
    },
    submit() {
      this.$refs.stripeElement.submit();
      this.isCreditCard = true;
      this.popupActive = false;
    },
    tokenCreated(token) {
      this.token = token;
      // for additional charge objects go to https://stripe.com/docs/api/charges/object
      this.charge = {
        source: token.id,
        amount: this.totalPrice, // the amount you want to charge the customer in cents. $100 is 1000 (it is strongly recommended you use a product id and quantity and get calculate this on the backend to avoid people manipulating the cost)
      };
      this.sendToServer(this.charge);
    },
    async sendToServer(charge) {
      // Send to charge to your backend server to be processed
      this.$vs.loading();
      var type = null;
      if (
        this.paymentType == 'CreditCard' ||
        this.paymentType == 'SavedCard' ||
        this.paymentType == 'ClinicBankAccount' ||
        this.paymentType == 'SavedClinicBankAccount' ||
        this.paymentType == 'PaymentTermsInvoice'
      ) {
        type = this.paymentType;
      } else if (this.paymentType) {
        type = 'StoredCard';
      }
      // Documentation here: https://stripe.com/docs/api/charges/create
      await this.paymentForCartItems({
        charge: charge,
        shippingDetails: this.shippingDetails,
        paymentType: type,
        cardId: type === 'StoredCard' ? this.paymentType : null,
        operations: this.operations,
      })
        .then((response) => {
          this.REMOVE_ALL_ITEMS_IN_CART();
          this.$vs.notify({
            title: response.data.title,
            text: response.data.message,
            color: 'success',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
          });
          this.$vs.loading.close();
          let name = 'ClinicOrderComplete';
          if (this.$store.state.AppActiveUser.userType === 'doctorClinic') {
            name = 'DoctorClinicOrderComplete';
          }

          if (this.role && this.role === 'org-owner') {
            name = 'OrgOwnerOrderComplete';
          }
          this.$router.push({
            name,
            query: {
              orderNumber: response.data.data.newOrder.orderNumber,
              orderId: response.data.data.newOrder._id,
            },
          });
        })
        .catch((error) => {
          if (['CreditCard', 'StoredCard'].includes(this.paymentType)) {
            // TODO: Are we using this?
          } else {
            if (error.data.title === 'OUTSTANDING_PAYMENT') {
              this.$vs.loading.close();
              this.popupActive2 = true;
              return;
            } else {
              this.$vs.loading.close();
              this.$vs.notify({
                title: error.data.title,
                text: error.data.message,
                color: 'danger',
                iconPack: 'feather',
                icon: 'icon-alert-circle',
              });
            }
            let name = 'OrderList';
            this.REMOVE_ALL_ITEMS_IN_CART();
            if (this.$store.state.AppActiveUser.userType === 'doctorClinic') {
              name = 'DoctorOrderList';
            }
            this.$router.push({ name });
          }
        });
    },
    getCartItems() {
      this.getCartItemsFromApi();
    },
    checkItemQuantity(quantity, data) {
      if (this.quantity < data.inventory.requiredQuantity) {
        this.errors.add({
          field: 'MinimumQuantityLimit',
          msg:
            'Minimum order quantity of ' +
            data.name +
            ' is ' +
            data.inventory.requiredQuantity,
          id: data._id,
        });
      } else {
        this.errors.remove('MinimumQuantityLimit');
      }
    },
    async nextTab() {
      let isValid = await this.$validator.validateAll('basic');
      if (!isValid) {
        this.$vs.notify({
          title: 'Error',
          text: 'Validation Failed',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger',
        });
        return false;
      }
      this.$refs.checkoutWizard.nextTab();
    },
    savedClinicBankPayment() {
      this.$vs.loading();

      this.paymentForCartItems({
        charge: this.totalPrice,
        shippingDetails: this.shippingDetails,
        paymentType: 'SavedClinicBankAccount',
      })
        .then((res) => {
          this.REMOVE_ALL_ITEMS_IN_CART();
          this.active1 = true;
          this.$vs.notify({
            title: res.data.title,
            text: res.data.message,
            color: 'success',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
          });
          this.getCartItems();
          this.$router.push({
            name: 'ClinicOrderComplete',
            query: {
              orderNumber: res.data.data.newOrder.orderNumber,
              orderId: res.data.data.newOrder._id,
            },
          });
          this.$vs.loading.close();
        })
        .catch(() => {
          this.REMOVE_ALL_ITEMS_IN_CART();
          this.$vs.loading.close();
        });
    },
    async getUserDetail() {
      const userDetail = await this.fetchUserDetails();
      const cardDetails = await this.fetchCardDetails();
      if (
        userDetail.data.data.paymentDetails &&
        userDetail.data.data.paymentDetails.cardId
      ) {
        this.defaultCard = cardDetails.data.data;
      }
      const cardDetailsList = await this.fetchCardDetailsList();
      this.cardDetails = cardDetailsList.data.data;
      this.isAccessPaymentTerms =
        typeof userDetail.data.data.isAccessPaymentTerms !== 'undefined'
          ? userDetail.data.data.isAccessPaymentTerms
          : false;

      if (userDetail.data.data.financialDetails) {
        this.financialDetails = userDetail.data.data.financialDetails;
        this.isNewClinicBankAccount = false;
      }
      if (userDetail.data.data.clinicOpeningHours) {
        const sched = { ...userDetail.data.data.clinicOpeningHours };
        delete sched._id;
        this.operations = {
          monday: sched.mondays,
          tuesday: sched.tuesdays,
          wednesday: sched.wednesdays,
          thursday: sched.thursdays,
          friday: sched.fridays,
          saturday: sched.saturdays,
          sunday: sched.sundays,
        };
      }

      return this.formatUserDetailResponse(userDetail.data.data);
    },
    formatUserDetailResponse(userDetail) {
      return {
        clinicName: userDetail.clinicName,
        address: userDetail.address,
        email: userDetail.email,
      };
    },
    // TAB 1
    removeItemFromCart(item) {
      this.$store.dispatch('eCommerce/toggleItemInCart', item);
    },
    wishListButtonClicked(item) {
      // Toggle in Wish List
      if (this.isInWishList(item.objectID))
        this.$router.push('/apps/eCommerce/wish-list').catch(() => { });
      else {
        this.toggleItemInWishList(item);
        this.removeItemFromCart(item);
      }
    },
    toggleItemInWishList(item) {
      this.$store.dispatch('eCommerce/toggleItemInWishList', item);
    },
    increase(item) {
      return _.debounce(()=>{
        // Disable input first
        this.disableInput=true;

        setTimeout(()=>{
          this.disableInput = false;
        },0);
        // Declare variables
        let cloneCart = _.cloneDeep(this.cartItems);
        let index = _.findIndex(cloneCart, { _id: item._id });

        // Checking if required quantity is met
        if (item.quantity < item.inventory.requiredQuantity) {
          this.errors.add({
            field: 'MinimumQuantityLimit',
            msg:
              'Minimum quantity for order is ' +
              item.inventory.requiredQuantity,
            id: item._id,
          });
          return;
        }

        // 1. Check if its empty
        // 2. Check if its less than 1
        if(!cloneCart[index].quantity || cloneCart[index].quantity<1){
          this.cartItems[index].quantity = 1;
          item.quantity = 1;
          cloneCart[index].quantity = 1;
          this.errors.add({
            field: 'MinimumQuantityLimit',
            msg: 'Minimum quantity for order is 1',
            id: item._id,
          });
        }

        // Check if its more than 999
        if(cloneCart[index].quantity>999){
          this.cartItems[index].quantity = 999;
          cloneCart[index].quantity = 999;
          this.errors.add({
            field: 'MaximumQuantityLimit',
            msg: 'Maximum quantity for order is 999',
            id: item._id,
          });
        }

        this.errors.removeById(item._id);
        this.$store.dispatch('eCommerce/updateItemQuantity', {
          item: item,
        });
      }, 500)();

    },
    decrease(_id) {
      let cloneCart = _.cloneDeep(this.cartItems);
      let index = _.findIndex(cloneCart, { _id });

      let item = cloneCart[index];

      if (item.quantity < item.inventory.requiredQuantity) {
        this.errors.add({
          field: 'MinimumQuantityLimit',
          msg:
            'Minimum quantity for order is ' + item.inventory.requiredQuantity,
          id: item._id,
        });
      } else {
        this.errors.removeById(item._id);
        this.$store.dispatch('eCommerce/updateItemQuantity', {
          item: item,
        });
      }
    },
  },
  components: {
    BankSetup,
    CheckoutListView,
    FormWizard,
    StripeElements,
    Tabs,
    PlusIcon,
    XIcon,
    SwapClinic,
  },
  beforeMount: async function () {
    if (
      localStorage.getItem(`${process.env.VUE_APP_PROCESS_TOKEN}OrganizationId`)
    ) {
      this.hasOrganization = true;
    }

    this.role = localStorage.getItem(
      `${process.env.VUE_APP_PROCESS_TOKEN}Role`
    );
  },
};
</script>

<style lang="scss" scoped>
#ecommerce-checkout-demo {
  .increment-buttons {
    height: 42px;
    background: #3cc9b230;
    width: 100px;
  }

  .item-view-primary-action-btn {
    color: #2c2c2c !important;
    background-color: #f6f6f6;
  }

  .item-name {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    overflow: hidden;
    -webkit-line-clamp: 2;
  }

  .vue-form-wizard {
    padding-bottom: 0;

    ::v-deep .wizard-header {
      padding: 0;
    }

    ::v-deep .wizard-tab-content {
      padding-right: 0;
      padding-left: 0;
      padding-bottom: 0;

      .wizard-tab-container {
        margin-bottom: 0 !important;
      }
    }
  }

  @media (min-width: 1024px) {
    .increment-buttons {
      border-radius: 5px;
    }

    .remove-button {
      border-radius: 5px;
    }
  }
}
</style>
